document.addEventListener("DOMContentLoaded", function() {
  const rotatingTextContainer = document.querySelector('.hero-rotating-text');
  const titles = Array.from(rotatingTextContainer.querySelectorAll('.hero-title'));
  
  // Initially hide all titles except the first
  titles.forEach((title, index) => {
    title.classList.toggle('active', index === 0);
  });

  let currentIndex = 0;

  function rotateTitle() {
    // Remove active class from current title
    titles[currentIndex].classList.remove('active');
    
    // Move to next title, wrapping around to start
    currentIndex = (currentIndex + 1) % titles.length;
    
    // Add active class to new title
    titles[currentIndex].classList.add('active');
  }

  // Rotate titles every 2 seconds
  setInterval(rotateTitle, 2000);
});